import { render } from "./Empty.vue?vue&type=template&id=bfaf5a60"
const script = {}

import exportComponent from "/opt/streamify/admin/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__